export const ATS_CAREER_SITE_ADMIN_SHARED = 'ATS_CAREER_SITE_ADMIN_SHARED ';
